import * as joi from "joi";

export const mariDataSchema = joi.object().keys({
  mariName: joi.string().min(1).required(),
  baseAddress: joi.string().min(1).required(),
  username: joi.string().min(1).required(),
  password: joi.string().min(1).required(),
});
